export const ZONE = 'America/Chicago';
const partsFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit'
});
export function todayKey() {
  const p = Object.fromEntries(partsFormatter.formatToParts(new Date()).map(x => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}`;
}
export function dayDate(key) { return new Date(key + 'T12:00:00Z'); }
export function addDays(key, count) {
  const date = dayDate(key);
  date.setUTCDate(date.getUTCDate() + count);
  return date.toISOString().slice(0, 10);
}
export function daysFor(anchor, view) {
  const first = view === 'month' ? anchor.slice(0, 7) + '-01' : anchor;
  const start = addDays(first, -dayDate(first).getUTCDay());
  return Array.from({ length: view === 'month' ? 42 : 7 }, (_, i) => addDays(start, i));
}
export function moveAnchor(anchor, view, direction) {
  if (view !== 'month') return addDays(anchor, direction * 7);
  const date = dayDate(anchor.slice(0, 7) + '-01');
  date.setUTCMonth(date.getUTCMonth() + direction);
  return date.toISOString().slice(0, 10);
}
export function dayLabel(day, options) {
  return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', ...options }).format(dayDate(day));
}
export function timeLabel(local) {
  const hour = Number(local.slice(11, 13));
  return `${hour % 12 || 12}:${local.slice(14, 16)} ${hour >= 12 ? 'PM' : 'AM'}`;
}
export function eventOnDay(event, day) {
  return event.startLocal < day + 'T24:00' && event.endLocal > day + 'T00:00';
}
export function timeRange(event) {
  const endDay = event.endLocal.slice(0, 10);
  const endPrefix = endDay !== event.startLocal.slice(0, 10) ? dayLabel(endDay, { month: 'short', day: 'numeric' }) + ' ' : '';
  return `${timeLabel(event.startLocal)} – ${endPrefix}${timeLabel(event.endLocal)}`;
}
